<template>
  <div class="app-slider">
    <div class="app-slider-inner">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in sliders" :key="index">
          <a class="img-box" :href="item.titleurl">
            <img :src="item.picture" alt class="slider-img" />
            <!-- <p class="title">{{item.title}}</p> -->
          </a>
        </swiper-slide>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';

import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  props: {
    sliders: {
      type: Array,
      default: [],
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      },
    };
  },
  mounted() {},
};
</script>
<style lang="scss">
@import '@/assets/styles/variable.scss';
.app-slider {
  position: relative;
  height: $slider_height;
  .app-slider-inner {
    position: absolute;
    width: 1400px;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    .img-box {
      display: block;
      width: 100%;
      height: $slider_height;
      position: relative;
      .slider-img {
        width: 100%;
        height: 100%;
      }
      .title {
        position: absolute;
        font-size: 26px;
        font-weight: bold;
        color: #fff;
        top: 0;
        line-height: $slider_height/2;
        text-align: center;
        width: 100%;
        text-shadow: 1px 1px 1px $theme_color;
      }
      .more {
        position: absolute;
        top: $slider_height/2;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        width: 100px;
        height: 36px;
        font-weight: bold;
        background: rgba(255, 255, 255, 0.8);
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        border-radius: 2px;
        &:hover{
          background: #db3b23;
          color: #fff;
        }
      }
    }
  }
  .swiper-pagination-bullet-active {
    background: $theme_color;
  }
  .swiper-pagination-bullet{
    width: 16px;
    height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/slider/Index.vue